export default [
  {
    path: '/student-profile',
    name: 'student_profile',
    permission: 'access_profile_personal',
    component: () => import('@/views/for_student/profile/personal'),
    meta: {
      permission: ['access_tab_profile', 'access_profile_personal'],
      pageTitle: 'personal',
      breadcrumb: [{ text: 'personal', active: true }],
    },
  },

  {
    path: '/student-academic',
    name: 'student_academic',
    permission: 'access_profile_academic',
    component: () => import('@/views/for_student/profile/academic'),
    meta: {
      permission: ['access_tab_profile', 'access_profile_academic'],
      pageTitle: 'academic',
      breadcrumb: [{ text: 'academic', active: true }],
    },
  },
  {
    path: '/offering/registration',
    name: 'offering_registration',
    component: () => import('@/views/for_student/offering/registration'),
    meta: { permission: ['access_registrations'], pageTitle: 'Course Registration', breadcrumb: [{ text: 'Course Registration', active: true }] },
  },
  {
    path: '/services',
    name: 'Other',
    permission: "access_tab_services",
    component: () =>import('@/views/for_student/service/services/index'),
    meta: {
      permission: ['access_tab_services'],
      pageTitle: 'Services',
      breadcrumb: [{ text: 'Services'}],
    },
  },
  {
    path: '/services/add',
    name: 'new_service',
    permission: "access_tab_services",
    component: () =>import('@/views/for_student/service/services/add'),
    meta: {
      permission: ['access_tab_services'],
      pageTitle: 'Services',
      navActiveLink: 'Other',
      breadcrumb: [{text : 'Services',to: '/services'},{text: 'Add',active: true}],
    },
  },
  {
    path: '/services/show/:id',
    name: 'other_show',
    permission: "access_tab_services",
    component: () =>import('@/views/for_student/service/services/show'),
    meta: {
      permission: ['access_tab_services'],
      pageTitle: 'Services',
      navActiveLink: 'Other',
      breadcrumb: [{text : 'Services',to: '/services'},{text: 'show',active: true}],
    },
  },
  {
    path: '/services/certification',
    name: 'certification',
    permission: 'access_services_certificates',
    component: () => import('@/views/for_student/service/certification/index'),
    meta: {
      permission: ['access_other_services', 'access_services_certificates'],
      pageTitle: 'Certificates',
      breadcrumb: [{ text: 'Certificates' }],
    },
  },
  {
    path: '/certification/show/:id',
    name: 'show_certificate',
    permission: 'access_services_certificates',
    component: () => import('@/views/for_student/service/certification/show'),
    meta: {
      permission: ['access_other_services', 'access_services_certificates'],
      pageTitle: 'Certificates',
      breadcrumb: [{ text: 'Certificates' }],
    },
  },
  {
    path: '/services/certification/add',
    name: 'add_certification',
    permission: 'access_services_certificates',
    component: () => import('@/views/for_student/service/certification/add'),
    meta: {
      permission: ['access_other_services', 'access_services_certificates'],
      pageTitle: 'Certificates',
      breadcrumb: [{ text: 'Certificates', active: true }],
    },
  },
  {
    path: '/services/certification/edit/:id',
    name: 'edit_certification',
    permission: 'access_services_certificates',
    component: () => import('@/views/for_student/service/certification/add'),
    meta: {
      permission: ['access_other_services', 'access_services_certificates'],
      pageTitle: 'Certificates',
      breadcrumb: [{ text: 'Certificates', active: true }],
    },
  },
  {
    path: '/my-exam-schedules',
    name: 'my_exam_schedules',
    permission: 'access_my_exam_schedules',
    component: () => import('@/views/for_student/my_exam_schedules/index'),
    meta: {
      permission: ['access_dashboard', 'access_my_exam_schedules'],
      pageTitle: 'My Exam Schedules',
      breadcrumb: [{ text: 'My Exam Schedules', active: true }],
    },
  },
  {
    path: '/myCourses',
    name: 'my_courses',
    permission: 'access_my_courses',
    component: () => import('@/views/for_student/my_courses/index'),
    meta: {
      permission: ['access_dashboard', 'access_my_courses'],
      pageTitle: 'My Courses',
      breadcrumb: [{ text: 'My Courses', active: true }],
    },
  },
  {
    path: '/myCourses/:course_id',
    name: 'show_my_course',
    permission: 'access_my_courses',
    component: () => import('@/views/for_student/my_courses/show'),
    meta: {
      permission: ['access_dashboard', 'access_my_courses'],
      pageTitle: 'Show Course',
      breadcrumb: [{ to: '/myCourses', text: 'My Courses' }, { text: 'Show Course', active: true }],
    },
  },
  {
    path: '/my_excuses',
    name: 'my_excuses',
    permission: 'access_student',
    component: () => import('@/views/for_student/my_excuses/index'),
    meta: { permission: ['access_services_excuses'], pageTitle: 'My Excuses', breadcrumb: [{ text: 'Excuses', active: true }] },
  },
  {
    path: '/my_excuses/add',
    name: 'add_excuse',
    permission: 'access_student',
    component: () => import('@/views/for_student/my_excuses/edit.vue'),
    meta: { permission: ['access_services_excuses'], pageTitle: 'Excuses', breadcrumb: [{ to: '/my_excuses', text: 'Excuses' }] },
  },
  {
    path: '/my_excuses/edit/:id',
    name: 'edit_excuse',
    permission: 'access_student',
    component: () => import('@/views/for_student/my_excuses/edit.vue'),
    meta: { permission: ['access_services_excuses'], pageTitle: 'Excuses', breadcrumb: [{ to: '/my_excuses', text: 'Excuses' }] },
  },

  {
    path: '/correction_requests',
    name: 'my_correction_requests',
    permission: 'access_profile_corrections',
    component: () => import('@/views/for_student/correction_requests/index'),
    meta: {
      permission: ['access_tab_profile', 'access_profile_corrections'],
      pageTitle: 'My Correction Requests',
      breadcrumb: [{ text: 'My Correction Requests', active: true }],
    },
  },
  {
    path: '/correction_requests/add',
    name: 'add_correction_request',
    component: () => import('@/views/for_student/correction_requests/add'),
    meta: {
      permission: ['access_tab_profile', 'access_profile_corrections'],
      pageTitle: 'My Excuses',
      breadcrumb: [
        { to: '/correction_requests', text: 'My Correction Requests' },
        { text: 'Request New Correction', active: true },
      ],
    },
  },
  {
    path: '/schedule',
    name: 'my_schedule',
    component: () =>
      import('@/views/for_student/my_schedule/index'),
    meta: { pageTitle: 'My Schedule', breadcrumb: [{ text: 'Schedule', active: true }] },
  },
  {
    path: '/calendar',
    name: 'my_calendar',
    component: () =>
      import('@/views/for_student/my_calendar/index'),
    meta: { permission: ['access_calender'], pageTitle: 'My Calendar', breadcrumb: [{ text: 'Calendar', active: true }] },
  },

  //My Thesis
  {
    path: '/my_thesis',
    name: 'my_thesis',
    // permission: 'access_theses',
    component: () => import('@/views/for_student/my_thesis/show'),
    meta: { pageTitle: 'my_thesis', breadcrumb: [{ text: 'my_thesis', active: true }] },
  },
  {
    path: '/my_theses/:id',
    name: 'show_thesis',
    // permission: 'access_theses',
    component: () => import('@/views/for_student/my_thesis/show'),
    meta: { pageTitle: 'Show Thesis', breadcrumb: [{ to: '/my_theses', text: 'my_theses' }, { text: 'Show Thesis', active: true }] },
  },
  {
    path: '/my_theses/add',
    name: 'add_thesis',
    // permission: 'add_thesis',
    component: () => import('@/views/for_student/my_thesis/edit'),
    meta: { pageTitle: 'my_theses', breadcrumb: [{ to: '/my_theses', text: 'my_theses' }] },
  },
  {
    path: '/my_theses/edit/:id?',
    name: 'edit_thesis',
    // permission: 'edit_thesis',
    component: () => import('@/views/for_student/my_thesis/edit'),
    meta: { pageTitle: 'my_theses', breadcrumb: [{ to: '/my_theses', text: 'my_theses' }] },
  },
  {
    path: '/my_credit',
    name: 'credit',
    permission: 'access_financial_credit',
    component: () => import('@/views/for_student/my_credit/index'),
    meta: {
      permission: ['access_tab_financial', 'access_financial_credit'],
      pageTitle: 'credit',
      breadcrumb: [{ text: 'credit', active: true }],
    },
  },
  {
    path: '/my_credit/charge',
    name: 'charge_credit',
    permission: 'access_financial_credit',
    component: () => import('@/views/for_student/my_credit/edit.vue'),
    meta: {
      permission: ['access_tab_financial', 'access_financial_credit'],
      pageTitle: 'credit',
      breadcrumb: [{ to: '/credit', text: 'credit' }],
    },
  }
];
